export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20minimalist%20product%20curation%20scene%20with%20neatly%20arranged%20fashion%20items%20including%20sneakers%20folded%20hoodies%20caps%20and%20small%20accessories%20on%20a%20warm%20cream%20surface%20natural%20daylight%20from%20large%20window%20soft%20shadows%20editorial%20catalog%20photography%20clean%20aesthetic%20gentle%20earthy%20tones%20no%20harsh%20colors&width=1800&height=1200&seq=hero-main-v2-2026&orientation=landscape"
          alt="Curated pandabuy sheet product collections"
          className="w-full h-full object-cover object-top"
          title="Pandabuy Sheet curated product hub"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left pt-16 md:pt-20">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-tight">
              The Ultimate{' '}
              <span className="italic font-normal text-accent-400">Pandabuy Sheet</span>
              <br />
              Product Hub
            </h1>
            <p className="mt-4 md:mt-6 text-base md:text-lg text-background-50/80 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Discover the best pandabuy sheet collections for clothing, sneakers, accessories, and viral products — curated daily for quality-conscious shoppers worldwide.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-6 md:mt-8 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-external-link-line mr-2"></i>
                Pandabuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-50/40 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/15 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line mr-2"></i>
                Buy It Now
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-6 md:mt-8">
              <span className="flex items-center gap-1.5 text-xs text-background-50/60 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill text-accent-400"></i> Updated Daily
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-50/60 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill text-accent-400"></i> Curated Quality
              </span>
              <span className="flex items-center gap-1.5 text-xs text-background-50/60 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill text-accent-400"></i> Budget &amp; Luxury
              </span>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative rounded-3xl overflow-hidden bg-background-50/10 backdrop-blur-sm border border-background-50/15 p-4">
              <div className="bg-background-50 rounded-2xl p-5">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                    Trending Spreadsheet Preview
                  </span>
                  <span className="px-2.5 py-1 bg-accent-500/15 text-accent-700 rounded-full text-xs font-semibold whitespace-nowrap">
                    LIVE
                  </span>
                </div>
                <div className="space-y-2.5">
                  {['Nike Air Force 1 Best Batches', 'Essentials Hoodie Budget Finds', 'Yeezy Slide Top Quality', 'Chrome Hearts Luxury Dupes', 'Carhartt Vintage Collection'].map((item, i) => (
                    <div
                      key={i}
                      className="flex items-center gap-3 py-2 px-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
                    >
                      <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <span className="text-xs font-bold text-accent-600">{(i + 1).toString().padStart(2, '0')}</span>
                      </span>
                      <span className="text-sm text-foreground-800 font-medium">{item}</span>
                      <span className="ml-auto text-xs text-accent-600 font-semibold whitespace-nowrap">
                        <i className="ri-arrow-right-up-line"></i>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}